module.exports = __webpack_public_path__ + "img/beecoins-1.9963d9c3.svg";